import { FormSchema, FormSchemaRef, FormSchemaServiceSearchResponse } from 'pbts/c1/api/form/v1/form'
import { FormSchemaServiceClient } from 'pbts/c1/api/form/v1/form.client'
import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const searchFormSchemasApi = createPagedListApi(
    FormSchemaServiceClient,
    'search',
    (response: FormSchemaServiceSearchResponse) => response.list,
    FormSchemaRef.typeName,
)

export const getFormSchemaApi = createUnaryApi(
    FormSchemaServiceClient,
    'get',
    (response) => response.formSchema as FormSchema,
    FormSchemaRef.typeName,
)

export const createFormSchemaApi = createMutationApi(
    FormSchemaServiceClient,
    'create',
    (response) => {
        if (!response.formSchema) {
            throw new Error('FormSchema not found in response')
        }
        return response.formSchema
    },
    FormSchemaRef.typeName,
)

export const updateFormSchemaApi = createMutationApi(
    FormSchemaServiceClient,
    'update',
    (response) => {
        if (!response.formSchema) {
            throw new Error('FormSchema not found in response')
        }
        return response.formSchema
    },
    FormSchemaRef.typeName,
)
